const n = (t = "") => {
  if (t === null || !t.trim())
    return t;
  const e = (t ?? "").toLocaleUpperCase().split(" ").filter((r) => r.trim());
  return e.length > 1 ? e.splice(0, 2).reduce((r, i) => r + i[0], "") : e[0].slice(0, 2);
};
export {
  n as getInitials
};
